import { isMswEnabled } from 'utils/environment'
import accountHandlers from './account/accountHandlers'
import agreementsHandlers from './agreements/agreementsHandlers'
import apiKeysHandlers from './apiKeys/apiKeysHandlers'
import approvalsHandlers from './approvals/approvalsHandlers'
import authHandlers from './auth/authHandlers'
import beneficiariesHandlers from './beneficiaries/beneficiariesHandlers'
import channelHandlers from './channels/channelHandlers'
import contactHandlers from './contacts/contactHandlers'
import countriesHandlers from './countries/countriesHandlers'
import customersHandlers from './customers/customersHandlers'
import { fiatDepositHandlers } from './fiatDeposit/fiatDepositHandlers'
import merchantsHandlers from './merchants/merchantsHandlers'
import passwordHandlers from './password/passwordHandlers'
import paymentsHandlers from './payments/paymentsHandlers'
import rewardsHandlers from './rewards/rewardsHandlers'
import rewardsTransactionsHandlers from './transactions/rewardsTransactions'
import transactionsExportHandlers from './transactions/transactionsExportHandlers'
import { getTransactionsByWalletId } from './transactions/transactionsHandlers'
import userDetailsHandlers from './userDetails/userDetailsHandlers'
import { getRewardsWallets } from './wallets/rewardsWalletHandlers'
import walletHandlers from './wallets/walletHandlers'

export const handlers = [
  ...(!isMswEnabled ? authHandlers : []),
  ...userDetailsHandlers,
  ...accountHandlers,
  ...approvalsHandlers,
  ...agreementsHandlers,
  ...passwordHandlers,
  getTransactionsByWalletId,
  ...channelHandlers,
  ...apiKeysHandlers,
  ...paymentsHandlers,
  ...countriesHandlers,
  ...customersHandlers,
  ...fiatDepositHandlers,
  ...walletHandlers,
  ...merchantsHandlers,
  ...beneficiariesHandlers,
  ...transactionsExportHandlers,
  ...contactHandlers,
  ...rewardsHandlers,
  ...rewardsTransactionsHandlers,
  getRewardsWallets,
]
